<template>
  <div id="doc-digitalizacao" class="font-doc-component">

    <div class="docIntroducao margem-app" :class="{'hidden':!telas.introducao}">
      <DocIntroducao :callback="this.capturar" :frente="frente"></DocIntroducao>
    </div>

    <div class="docConfirmacao margem-app" :class="{'hidden':!telas.confirma}">
      <DocConfirmacao
          :doc="this.confirma.doc"
          v-on:callBackSucesso="resumirCaptura"
          v-on:callBackFalha="reiniciarCaptura"
          :frente="frente"></DocConfirmacao>
    </div>

    <div class="docCaptura" :class="{'hidden':!telas.doc,'doc_susseso_captura':sucesso_captura,'captura_manual':capturaManual}">
      <DocCaptura :texto="texto"></DocCaptura>
    </div>

    <div class="tela-erro margem-app" :class="{'hidden':!telas.erro}">
      <Error
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          :secound-button-text="error.btnDoisTxt"
          :secound-button-callback="this.voltarTelaSelecaoDoc"
          :callback="this.errorCallback"
      ></Error>
    </div>
  </div>
</template>

<script>

import AppService from "../../services/AppService";
import DispatchTags from "../../utils/DispatchTags";
import Tools from "../../utils/Tools";

import DocCaptura from "../shared/DocCaptura";
import DocIntroducao from "../shared/DocIntroducao";
import DocConfirmacao from "../shared/DocConfirmacao";
import Error from "../shared/Error";
import Dicas from "../shared/Dicas";


const TEXTOS = {
  doc_frente:"Coloque a parte da frente do <br/> documento na moldura",
  doc_verso:"Enquadre na moldura a parte de trás <br/> (verso) do documento",
  capturando_doc:"Estamos tirando a foto <br/> Mantenha o celular nesta posição",
  sucesso_captura:"Pronto! Tiramos a foto <br/> Aguarde a validação do documento",
  erro_generico: "Algo deu errado ao tirar a foto de seu documento",
  erro_confirmar: "Algo deu errado ao confirmar seu documento"
}
export default {
  name: "DocDigitalizacao",
  components: {Dicas, DocConfirmacao, DocIntroducao, DocCaptura,Error},
  data:function (){
    return {
      permitiu_modal:false,
      permicao_camera:true,
      frente: true,
      docController:null,
      documentos:[],
      docAtual:null,
      texto: '',
      isErro: false,
      confirma:{
        doc:""
      },
      telas:{
        introducao:true,
        doc:false,
        confirma:false,
        erro:false
      },
      error:{
        title: "",
        subtitle: "",
        btnDoisTxt:"",
        resetCaptura:false,
        btnTitle:"Tentar de novo",
        number: 0,
        callBackError: 0,
        exibeTelaDicas:false
      },
      gtm:{
        'CNH': {
          take:{
            frente: 'SuccessCaptureFrontDocCnh',
            verso: 'SuccessCaptureBackDocCnh'
          },
          screenview:{
            frente:'DocDigitalizacaoCnhFront',
            verso:'DocDigitalizacaoCnhBack'
          },
          checked:{
            frente:'checkDocCnhFrontPicture',
            verso:'checkDocCnhBackPicture'
          },
        },
        'RG':{
          take:{
            frente: 'SuccessCaptureFrontDocRg',
            verso: 'SuccessCaptureBackDocRg'
          },
          screenview:{
            frente:'DocDigitalizacaoRgFront',
            verso:'DocDigitalizacaoRgBack'
          },
          checked:{
            frente:'checkDocRgFrontPicture',
            verso:'checkDocRgBackPicture'
          }
        },
        'OUTRO':{
          take:{
            frente: 'SuccessCaptureFrontDocOutros',
            verso: 'SuccessCaptureBackDocOutros'
          },
          screenview:{
            frente:'DocDigitalizacaoOutrosFront',
            verso:'DocDigitalizacaoOutrosBack'
          },
          checked:{
            frente:'checkDocOutrosFrontPicture',
            verso:'checkDocOutrosBackPicture'
          }
        }
      },
      sucesso_captura:false,
      video:{
        pause:false,
        listener:null
      },
      capturaManual:false,
      timeOutCapturaManual:null,
      pausaCallback: false,
      manter_estavel:false,
      modelo_carregado:false,
      intervalToken:null,
    }
  },
  created() {
    this.appService = new AppService();
    this.appService.preLoadDocumento();
  },
  mounted() {
    if(this.$store.getters.tipoCaptura !== 1 && this.$store.getters.indApiN1 !== 1){
      this.$router.push({name:'Analise'});
      return;
    }
    this.$store.dispatch('setTitulo','Confirmar identidade');
    this.$store.dispatch('setLoadingStatus',false);
    this.ChekIniciouVideo();
    this.texto = TEXTOS.doc_frente;
    window.documento.capturaAutomatica.capturaPausada = false;
  },
  beforeRouteEnter(to, from,next) {
    if(window.selfieVideoStream) {
      window.selfieVideoStream.getTracks().forEach(function (track) {
        track.stop();
      });
    }
    next();
  },
  beforeRouteLeave(to, from,next) {
    this.iniciaDocumento();
    this.destroiListenerVideo();
    this.clearIntervalBuscarToken();
    window.documento.sucessoCapturaDocumento();
    delete window.documento;
    next();
  },
  computed:{
    tipoDoc:function (){
      return this.$store.getters.tipoDoc;
    }
  },
  methods: {
    capturar: function () {

      let gtmData = this.gtm[this.tipoDoc].screenview;
      let gtmLabel = (this.frente) ? gtmData.frente : gtmData.verso;
      DispatchTags.dispatchScreenView(gtmLabel);
      if (this.docController === null) {
        this.iniciaDocumento();
        return;
      }
      this.hiddenAll();
      this.telas.doc = true;
      this.docController.resumirCaptura();
      this.alteraTexto('encaixe o documento');
      this.iniciaCallback();
      this.mostrarBotaoCapturaManual();
    },
    reiniciarCaptura: function () {
      let gtmData = this.gtm[this.tipoDoc].screenview;
      let gtmLabel = (this.frente) ? gtmData.frente : gtmData.verso;
      DispatchTags.dispatchScreenView(gtmLabel);
      if(this.frente){
        this.docController.reiniciarCaptura();
      }else{
        this.docController.resumirCaptura();
      }

      this.hiddenAll();
      this.alteraTexto('encaixe o documento');
      this.iniciaCallback();
      this.mostrarBotaoCapturaManual();
      this.telas.doc = true;
    },
    resumirCaptura: function () {

      this.hiddenAll();
      this.documentos.push(this.docAtual);
      this.docAtual = null;

      if (this.documentos.length === 2) {
        this.$store.dispatch('setLoadingStatus', true);
        this.sucesso();
        return;
      }

      this.iniciaCallback();
      this.frente = false;
      this.telas.introducao = true;
    },
    iniciaDocumento: function () {
      this.hiddenAll();
      this.$store.dispatch('setLoadingStatus', true);
      this.telas.doc = true;
      let doc = window.documento;
      doc.timeoutCaptura = 0;
      if (this.$store.getters.tipoDoc === this.appService.tipoDOC().outro) {
        this.capturaManual = true;
        doc.habilitaCapturaManual();
      }
      var criarListener = false;
      this.intervalBuscarToken();
      doc.iniciaCaptura(document.getElementById('documento'), (id, data, controller) => {
        if(this.pausaCallback){
          return;
        }
        this.docController = controller;
        switch (id) {
          case "loading":
            if(!this.modelo_carregado){
              return;
            }
            this.$store.dispatch('setLoadingStatus', data);
            break;
          case "modelo_carregado":
            this.modelo_carregado = data;
            if(this.modelo_carregado){
              this.$store.dispatch('setLoadingStatus', false);
              this.mostrarBotaoCapturaManual();
            }
            if (data && !criarListener) {
              criarListener = true;
              this.criarListernerVideo();
            }
            break;
          case "liberar_camera":
            this.permicao_camera = data;
            if (false === data) {
              this.exibirErro('Precisamos desse acesso pra tirar a foto e confirmar sua identidade');
            }
            break;
          case  "documento_nao_reconhecido":
            this.pauseCallback();
            this.exibirErro();
            break;
          case "altera_texto":
            this.alteraTexto(data);
            break;
          case  'documento_capturado_diferente_anterior':
            this.error.exibeTelaDicas = true;
            let btnTxt = (this.frente) ? "Escolher outro documento ›" : ""
            this.exibirErro('Parece que o documento que você está tentando tirar a foto é diferente do documento escolhido para validação',3,btnTxt);
            this.gtmErrorReport(3);
            this.error.number = 3;
            break;
          case  'documento_capturado_lado_igual':
            this.error.exibeTelaDicas = true;
            let lado = (this.frente) ? 'da frente' : 'do verso';
            let t = `Parece que o lado do documento está errado. Primeiro, você precisa tirar a foto apenas da parte ${lado} do documento`;
            this.exibirErro(t,2);
            this.gtmErrorReport(2);
            this.error.number = 2;
            break;
          case "documento_lado_ab":
          case "captura_ab":
            this.error.exibeTelaDicas = true;
            let l = (this.frente) ? 'da frente' : 'do verso';
            let t2 = `Parece que o lado do documento está errado. Primeiro, você precisa tirar a foto apenas da parte ${l} do documento`;
            this.exibirErro(t2,4);
            this.gtmErrorReport(4);
            this.error.number = 4;
            this.pauseCallback();
            this.error.resetCaptura = true;
            break;
          case 'documento_sem_tipo':
            if (this.$store.getters.tipoDoc !== this.appService.tipoDOC().outro) {
              this.pauseCallback();
              this.exibirErro();
              break;
            }
            data.lado = (this.frente) ? 'a' : 'b';
            data.tipo = 'outro';
            data.documento = data.base64;
            data.base64 = null;
            this.sucessoCaptura(data);
            break;
          case 'capturar_proximo_lado':
            this.sucessoCaptura(data);
            break;
        }
      }).catch(err => this.$router.replace({name: 'Falha'}));
    },
    hiddenAll: function () {
      Object.keys(this.telas).forEach(v => this.telas[v] = false);
    },
    exibirErro: function (subtile, number,btnDoisTxt = "") {
      this.pauseCallback();
      if(this.isErro){
        return;
      }
      this.error.btnDoisTxt = btnDoisTxt;
      this.isErro = true;
      this.hiddenAll();
      this.error.title = (subtile) ? TEXTOS.erro_confirmar : TEXTOS.erro_generico;
      this.error.subtitle = (subtile) ? subtile : "Você pode tentar de novo ";
      number = (typeof number === 'undefined' || number === null) ? 1 : number;
      this.error.callBackError = number;
      let oldScreen = Tools.makeHistoryScreenNameDocument(this.tipoDoc,number,this.frente);
      DispatchTags.dispatchDynamicScreenView(oldScreen);
      let blocker = (this.permicao_camera) ? 'blocker' : 'nomBlocker';
      let docType = {'CNH':'driversLicense','RG':'idCard', 'OUTRO':'otherDocuments'};
      let desc = Tools.sanitize(this.error.title);
      let montaEnumErro = Tools.setErrorGmt(blocker,docType[this.tipoDoc],desc,number);
      DispatchTags.dispatchDynamicNoninteraction(montaEnumErro);
      // this.error.number = number;
      this.telas.erro = true;
      this.$store.dispatch('setLoadingStatus', false);

    },
    gtmErrorReport: function (errorNumber) {
      let blocker = (this.permicao_camera) ? 'blocker' : 'nomBlocker';
      let docType = {'CNH':'driversLicense','RG':'idCard', 'OUTRO':'otherDocuments'};
      let desc = Tools.sanitize(this.error.title);
    },
    errorCallback: function () {
      let numberErrorCalback = (this.error.callBackError === 0 || this.error.callBackError === null) ? 1 : this.error.callBackError;
      DispatchTags.dispatchInraction('DocError' + numberErrorCalback);
      this.isErro = false;
      this.hiddenAll();
      this.telas.doc = true;


      if (this.permicao_camera) {
        this.iniciaCallback();
        this.docController.resumirCaptura()
        this.esconderBotaoCapturaManual();
        this.mostrarBotaoCapturaManual();
        return;
      }


      if(this.error.exibeTelaDicas){
        this.error.exibeTelaDicas = false;
        if(this.error.resetCaptura){
          this.error.resetCaptura = false;
          this.docController.reiniciarCaptura();
        }
        this.exibirTelaDicasDoc();
        return;
      }

      if (this.error.resetCaptura) {
        this.error.resetCaptura = false;
        this.reiniciarCaptura();
        return;
      }

      if (this.docController === null) {
        this.iniciaDocumento();
        return;
      }

      this.alteraTexto('encaixe o documento');
      this.docController.resumirCaptura();
      this.iniciaCallback();
      this.mostrarBotaoCapturaManual();
    },
    proximoLado: function (data) {
      this.esconderBotaoCapturaManual();
      this.$store.dispatch('setLoadingStatus', true);
      this.hiddenAll();

      let tipos = {
        'CNH': ['cnh','cnhcel2022','cnhdig2022'],
        'RG': ['rg', 'dni']
      };

      let t = this.$store.getters.tipoDoc;
      if (t !== this.appService.tipoDOC().outro && !tipos[t].includes(data.tipo)) {
        this.error.resetCaptura = true;
        this.error.exibeTelaDicas = true;
        window.documento.ladoDocumentoAtual = null;
        window.documento.tipoDocumentoAtual = null;
        let btnTxt = (this.frente) ? "Escolher outro documento ›" : "";
        this.exibirErro('Parece que o documento que você está tentando tirar a foto é diferente do documento escolhido para validação' , 3,btnTxt);
        return;
      }

      let gtmData = this.gtm[this.tipoDoc].take;
      let gtmDataScreen = (this.frente) ? this.gtm[this.tipoDoc].checked.frente : this.gtm[this.tipoDoc].checked.verso;
      let gtmLabel = (this.frente) ? gtmData.frente : gtmData.verso;
      DispatchTags.dispatchNoninteraction(gtmLabel);
      DispatchTags.dispatchScreenView(gtmDataScreen);

      this.docAtual = data;
      this.confirma.doc = data.documento;
      this.telas.confirma = true;
      this.$store.dispatch('setLoadingStatus', false);
    },
    sucesso: function () {
      this.documentos
          .forEach(arquivo => sessionStorage.setItem(arquivo.lado.toUpperCase(), arquivo.documento));
      this.destroiListenerVideo();
      window.documento.sucessoCapturaDocumento();
      this.$router.push({name: 'Analise'});
    },
    criarListernerVideo() {
      this.video.listener = setInterval(() => {
        if(typeof this.docController.capturaAutomatica == 'undefined'){
          return;
        }
        if (this.docController.capturaAutomatica.capturaPausada) {
          this.docController.capturaAutomatica.video.pause();
          this.docController.capturaAutomatica.pausaCaptura();
          this.video.pause = true;
        }
        if (!this.docController.capturaAutomatica.capturaPausada && this.video.pause) {
          this.docController.capturaAutomatica.video.play();
          this.docController.capturaAutomatica.resumirCaptura();
          this.video.pause = false;
        }
      }, 100);
    },
    destroiListenerVideo: function () {
      if (null !== this.video.listener) {
        clearInterval(this.video.listener);
        this.video.listener = null;
      }
    },
    sucessoCaptura: function (data) {
      this.pauseCallback();
      if(this.error.resetCaptura){
        return;
      }
      this.texto = TEXTOS.sucesso_captura;
      this.$store.dispatch('setLoadingStatus', false);
      this.sucesso_captura = true;
      setTimeout(() => {
        this.proximoLado(data);
        this.sucesso_captura = false;
      }, 500);
    },
    ChekIniciouVideo: function () {
      var interval = setInterval(() => {
        var cameraVideo = document.getElementById("cameraVideo");
        if (!cameraVideo) {
          return;
        }
        cameraVideo.autoplay = true;
        cameraVideo.addEventListener('click', () => cameraVideo.play(), false);
        this.loadBackgraund();
        var $video = $(cameraVideo);
        $video.trigger('click');
        $video.css('display', 'block');
        clearInterval(interval);
      }, 100);
    },
    mostrarBotaoCapturaManual:function (){
      var interval =  setInterval(() => {
        var cameraVideo = document.getElementById("cameraVideo");
        if (!cameraVideo) {
          return;
        }
        if (this.$store.getters.tipoDoc === this.appService.tipoDOC().outro) {
          this.capturaManual = true;
          $('#photoParent').show();
        } else {
          this.timeOutCapturaManual =  setTimeout(() => {
            $('#photoParent').show();
          },11000);
        }
        clearInterval(interval);
      }, 100);
    },
    esconderBotaoCapturaManual: function () {
      clearTimeout(this.timeOutCapturaManual);
      $('#photoParent').hide();
    },
    loadBackgraund:function (){
      let $container = $('#cameraVideo');
      let $backgraund = $('<div class="backgraund-shape"/>');
      let $divDelimitador = $('#delimitador-captura').clone(true);
      let $molduraVerdeTransparente = $('#moldura-verde-transparente').clone(true);
      let $moldura = $('#frame').clone(true);
      var $texto = $('#texto-captura-doc').clone(true);

      $('#frame').remove();
      $('#delimitador-captura').remove();
      $('#moldura-verde-transparente').remove();

      $divDelimitador.removeAttr('id');
      $divDelimitador.removeClass('hidden');

      $texto.removeAttr('id');
      $texto.removeClass('hidden');

      $molduraVerdeTransparente.removeAttr('id');
      $molduraVerdeTransparente.removeClass('hidden');

      $backgraund.append($moldura);
      $backgraund.append($texto);
      $backgraund.append($divDelimitador);
      $backgraund.append($molduraVerdeTransparente);

      $backgraund.insertBefore($container);
    },
    pauseCallback:function (){
      window.documento.capturaAutomatica.pausaCaptura()
      this.pausaCallback = true;
    },
    iniciaCallback:function (){
      setTimeout(_ => {
        window.documento.capturaAutomatica.resumirCaptura();
        this.pausaCallback = false;
      },500);
    },
    voltarTelaSelecaoDoc:function (){
      this.$router.replace({name:'DocSelecao'});
    },
    exibirTelaDicasDoc:function (){
      this.esconderBotaoCapturaManual();
      this.$store.dispatch('setLoadingStatus', true);
      this.hiddenAll();

      let gtmData = this.gtm[this.tipoDoc].take;
      let gtmDataScreen = (this.frente) ? this.gtm[this.tipoDoc].checked.frente : this.gtm[this.tipoDoc].checked.verso;
      let gtmLabel = (this.frente) ? gtmData.frente : gtmData.verso;
      DispatchTags.dispatchNoninteraction(gtmLabel);
      DispatchTags.dispatchScreenView(gtmDataScreen);

      this.alteraTexto('encaixe o documento');
      this.telas.introducao = true;
      this.$store.dispatch('setLoadingStatus', false);
    },
    alteraTexto(data){
      if (this.sucesso_captura) {
        return;
      }

      if($('.backgraund-shape').length == 0){
        return;
      }

      switch (data.toLowerCase().trim()) {
        case 'encaixe o documento':
        case 'centralize o documento':
          this.texto = (this.frente) ? TEXTOS.doc_frente : TEXTOS.doc_verso;
          break;
        case 'mantenha estável':
        case 'documento identificado':
          this.texto = TEXTOS.capturando_doc;
          break;
        default:
          this.texto = data;
          break;
      }
      $('.backgraund-shape').find('.texto-captura-doc p').html(this.texto);
    },
    intervalBuscarToken:function (){
      if(this.intervalToken === null){
        this.intervalToken = setInterval(_ => window.documento.servico.buscarToken(),480000);// aguarda 8 minutos para buscar um novo token
      }
    },
    clearIntervalBuscarToken:function (){
      if(this.intervalToken){
        clearInterval(this.intervalToken);
        this.intervalToken = null;
      }
    }
  }
}
</script>

<style scoped>
.hidden{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/DocDigitalizacao.vue